// extracted by mini-css-extract-plugin
export default {"container":"popup_container__XMefy","close":"popup_close__ItfW8","inner":"popup_inner__PCccG","overlay":"popup_overlay__VOW-K"};